module.exports = __webpack_public_path__ + "mainassets/img/plus-green.6e7bb4bf.svg";